import useGet from "../../../hooks/useGet";
import Table from "../../../components/table";
import columns from "./column";
import useTable from "../../../hooks/useTable";
import CardContainer from "../../../components/card_container";
import {
  ADDPRODUCTCATEGORY,
  EDITPRODUCTCATEGORY,
} from "../../../routes/routes_name";
import CustomModal from "../../../components/custom_modal";
import { useState } from "react";

const ProductCategoryPage = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const {
    filter,
    isLoading,
    data,
    error,
    totalPages,
    handlePagination,
    handleLimit,
    handleFilter,
  } = useGet("/v1/product-category");

  const {
    isLoading: isLoadingPost,
    dataRemove,
    handleEdit,
    handleSelected,
    handleRemove,
  } = useTable();

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <CardContainer
        title="List of Product Category"
        isHeader={true}
        addShow={dataRemove.length < 1}
        editShow={dataRemove.length === 1}
        // detailShow={dataRemove.length === 1}
        deleteShow={dataRemove.length >= 1}
        addClick={ADDPRODUCTCATEGORY}
        searchPlaceholder="Search code or category name"
        editClick={() => handleEdit(EDITPRODUCTCATEGORY)}
        detailClick={() => openModal()}
        deleteClick={() =>
          handleRemove({
            url: "/v1/product-category",
            descSuccess: "Product Category data has been successfully deleted.",
          })
        }
        onSearchChange={handleFilter}
      >
        <div className="expanded-y">
          <div className="table-content">
            <Table
              filter={filter}
              isLoading={isLoading}
              error={error}
              data={data}
              totalPages={totalPages}
              handlePagination={handlePagination}
              handleLimit={() => {}}
              handleChangeSelect={handleSelected}
              columns={columns}
            />
          </div>
        </div>
      </CardContainer>
    </>
  );
};
export default ProductCategoryPage;
